module.exports = __webpack_public_path__ + "static/media/9.7d7b9ce2.jpg";